import { ServiceFetch } from '../service-fetch'

export default class InvoiceSupplierDiscountListModel extends ServiceFetch {
    getInvoiceSupplierDiscountListBy = (data) => this.authFetch({
        url: 'invoice-supplier-discount-list/getInvoiceSupplierDiscountListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}